import React from 'react';
import Modal from './custom';

interface OwnProps {
  type: 'save' | 'cancel';
  text: string;
  onConfirm(): void;
  onCancel(): void;
}

type Props = OwnProps;

const ConfirmChanges = (props: Props) => {
  const handleConfirm = () => {
    props.onConfirm();
    props.onCancel();
  };

  return (
    <Modal
      title={props.type === 'save' ? 'Confirm changes' : 'Unsaved changes'}
      onClose={props.onCancel}
      content={props.text}
      onSave={handleConfirm}
      saveLabel={props.type === 'save' ? 'Confirm' : 'Yes, Leave'}
    />
  );
};

export default ConfirmChanges;
